module.exports = __webpack_public_path__ + "img/7.32ed1e4a.jpg";